import type { RExternalApp, RExternalAppDetails } from 'v2/types/api/settings'

/** The catalog's ranked apps, most-connected first. The bridge ranks them from real connections. */
export const selectPopularApps = (externalApps: RExternalApp): RExternalAppDetails[] => {
  const byId = new Map<string, RExternalAppDetails>()
  for (const apps of Object.values(externalApps ?? {})) {
    for (const app of (apps ?? []) as RExternalAppDetails[]) {
      if (app.popular_rank && !byId.has(app.id)) byId.set(app.id, app)
    }
  }
  return [...byId.values()].sort((a, b) => (a.popular_rank ?? 0) - (b.popular_rank ?? 0))
}
